import { LayoutModule } from '@angular/cdk/layout';
import { CommonModule } from '@angular/common';
import { HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import {
  MAT_MOMENT_DATE_FORMATS,
  MomentDateAdapter
} from '@angular/material-moment-adapter';
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE
} from '@angular/material/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import {
  FacebookLoginProvider,
  GoogleLoginProvider,
  SocialAuthServiceConfig,
  SocialLoginModule
} from 'angularx-social-login';
import { HttpLoaderFactory } from 'src/app/shared/utils/translate-utils';
import { AppRoutingModule } from '../app-routing.module';
import { MaterialModule } from '../material/material.module';
import { MatPaginatorI18nService } from '../services/i18n/mat-paginator-i18n.service';
import { SharedModule } from '../shared/shared.module';
import { LocaleInterceptor } from './auth/interceptors/locale-interceptor.service';
import { TokenInterceptor } from './auth/interceptors/token-interceptor.service';
import { AppLayoutComponent } from './layout/app-layout/app-layout.component';
import { TwoFactorDialogComponent } from './auth/components/two-factor-dialog/two-factor-dialog.component';
import { TwofaReminderDialogComponent } from './layout/twofa-reminder-dialog/twofa-reminder-dialog.component';

@NgModule({
  declarations: [
    AppLayoutComponent,
    TwoFactorDialogComponent,
    TwofaReminderDialogComponent
  ],
  imports: [
    CommonModule,
    LayoutModule,
    MaterialModule,
    FlexLayoutModule,
    AppRoutingModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    SocialLoginModule,
    SharedModule
  ],
  exports: [],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LocaleInterceptor,
      multi: true
    },
    {
      provide: MatPaginatorIntl,
      useClass: MatPaginatorI18nService
    },
    { provide: MAT_DATE_LOCALE, useValue: 'en' },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },
    { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
    {
      provide: 'SocialAuthServiceConfig',
      useValue: {
        autoLogin: false,
        providers: [
          {
            id: FacebookLoginProvider.PROVIDER_ID,
            provider: new FacebookLoginProvider('946892476330920')
          }
        ]
      } as SocialAuthServiceConfig
    }
  ]
})
export class CoreModule {}
